import Layout, { Content } from "antd/es/layout/layout";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import LeftNav from "../navigation/LeftNav";
import PageHeader from "../navigation/PageHeader";
import { routes } from "./routes";
import Overview from "../pages/Overview";
import Acquisition from "../pages/Acquisition";
import Funnel from "../pages/Funnel";
import Cohort from "../pages/Cohort";

const RootRoute: FC = () => {
  return (
    <Layout style={{ height: "100%" }}>
      <LeftNav />
      <Layout>
        <Content style={{ background: "#ffffff", padding: "10px 24px" }}>
          <PageHeader />
          <Content
            style={{
              margin: 0,
              height: "99%",
            }}
          >
            <Routes>
              <Route path={routes.default} element={<Overview />} />
              <Route path={routes.acquisition} element={<Acquisition />} />
              <Route path={routes.funnel} element={<Funnel />} />
              <Route path={routes.cohort} element={<Cohort />} />
            </Routes>
          </Content>
        </Content>
      </Layout>
    </Layout>
  );
};

export default RootRoute;
